import RentApartments from './rentApartmentsAttributes';
import RentCommercials from './rentCommercialsAttributes';
import RentDailyApartments from './rentDailyApartmentsAttributes';
import SaleApartments from './saleApartmentsAttributes';
import SaleCommercials from './saleCommercialsAttributes';
import SaleGarages from './saleGaragesAttributes';
import SaleLands from './saleLandsAttributes';

export default function (item) {
  const section = item.getDealType() + '_' + item.getRealtyType();

  switch (section) {
    case 'rent_apartments': return new RentApartments(item);
    case 'rent_commercials': return new RentCommercials(item);
    case 'rentDaily_apartments': return new RentDailyApartments(item);

    case 'sale_apartments': return new SaleApartments(item);
    case 'sale_commercials': return new SaleCommercials(item);
    case 'sale_garages': return new SaleGarages(item);
    case 'sale_lands': return new SaleLands(item);
  }
}



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/attributeFactory.js